<template>
	<div class='main-mybody'>
		<a-row>
				<a-col :span='24'>
					<div class='look_g'><div></div>使用者名稱與密碼</div>
					<a-row><a-col :span='4'>使用者名稱</a-col><a-col :span='7'>{{form.name}}</a-col></a-row>
					<a-row><a-col :span='4'>舊密碼</a-col><a-col :span='7'>********</a-col></a-row>
					<div class='main-wid'></div>
				</a-col>
				<a-col :span='24'>
					<div class='look_g'><div></div>安全性資訊問題</div>
					<a-row><a-col :span='4'>安全性問題1</a-col><a-col :span='7'>{{form.securityquestion1}}</a-col></a-row>
					<a-row><a-col :span='4'>答案</a-col><a-col :span='7' v-if='form.securityquestion1'>********</a-col></a-row>
					<a-row><a-col :span='4'>安全性問題2</a-col><a-col :span='7'>{{form.securityquestion2}}</a-col></a-row>
					<a-row><a-col :span='4'>舊答案</a-col><a-col :span='7' v-if='form.securityquestion2'>********</a-col></a-row>
					<a-row><a-col :span='4'>安全性問題3</a-col><a-col :span='7'>{{form.securityquestion3}}</a-col></a-row>
					<a-row><a-col :span='4'>舊答案</a-col><a-col :span='7' v-if='form.securityquestion3'>********</a-col></a-row>
					</a-col></a-row>
				</a-col>
		</a-row>
	</div>
</template>

<script>

	export default {
		props:['lookfrom'],
		data(){
			return {
					form:{}
			}
		},
		watch:{
			lookfrom:{
				deep:true,
				handler(ev){
					if(ev){
						this.form = JSON.parse(JSON.stringify(this.lookfrom))
					}
				}
			}
		},
		mounted() {
			this.form = JSON.parse(JSON.stringify(this.lookfrom))
		},
		methods:{
			numfn(val) {
				if(this.form[val]){
					if (isNaN(this.form[val])) {
						this.form[val] = ''
					} else {
						this.form[val] = parseInt(this.form[val])
					}
				}
			},
		}
	}
</script>

<style>
</style>
